<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
<mat-dialog-actions cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="title"  >
		{{ formTitle}}
		<app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="this.formState === 'Submitting'"></app-component-loading>
	</div>
	<mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<div class="avatars-list">
    <div class="avatars-list-search">
      <mat-icon svgIcon="search-line" class="base-icon" style="width: 18px;"></mat-icon>
        <input matInput  
                [formControl] = "searchControl" 
                [placeholder]="'INDEX_PAGE.OFFICE.TEXT.SEARCH' | translate" 
                class="avatars-list-search-input body-m-regular text-extra">
    </div>
    <div class="avatars-list-item">
        <div class="avatars-list-item-avatar" > </div>
        <div class="avatars-list-item-text title" > {{ 'INDEX_PAGE.OFFICE.TEXT.FULL_NAME' | translate }} </div>
        <div class="avatars-list-item-text title"> Email </div>
        <div class="avatars-list-item-text title">{{'INDEX_PAGE.OFFICE.TEXT.POSITION' | translate  }} </div>
        <div class="avatars-list-item-text title">{{'MODALS.FIELDS.ROLE' | translate  }} </div>
    </div>
    @for (user of users; track user.guid) {
        <div class="avatars-list-item">
            <div class="avatars-list-item-avatar">
                <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="user.guid"> </app-contract-avatar>
            </div>
            <div class="avatars-list-item-text"
                [class.blocked_user]="user.project_setting.observation_type === 'blocked'" 
                [class.inactive_user]="!user.is_active"
                >
                    {{helper.fullName(user)}}
            </div>
            <div class="avatars-list-item-text"  >  {{ user.email}}           </div>
            <div class="avatars-list-item-text"  >  {{ user.project_setting.position ?? '-' }}           </div>
            <mat-select class="avatars-list-item-select body-m-regular text-extra select-rotate" #select
                        [disabled]="formState === 'Submitting' || addedUsers.includes(user.guid)"
                        disableRipple panelClass="nd-select-roles" 	
                        [placeholder]="('BUTTON_TEXT.SELECT' | translate) + ' роль' " 	>
                <mat-option  *ngIf="select.value" class="body-m-regular avatars-list-item-select-option" [value]="">Не добавлять</mat-option>
                @for (role of  this.rolesToSelcet;  track role) {
                    <mat-option  class="body-m-regular avatars-list-item-select-option" [value]="role"  >
                        <div>{{('TASKS.TEXT.TASK_ROLES.' + role)|translate}}</div> 
                    </mat-option>
                }
            </mat-select>
            <button *ngIf="select.value" 
                [disabled]="formState === 'Submitting' || addedUsers.includes(user.guid)"
                (click)="addUser(user,select)" data-action="addUser"
                [matTooltip] = "'TASKS.TOOLTIPS.ADD_PARTY_TO_TASK' | translate"    
                class="button-icon icononly size-m secondary-button">
                <mat-icon svgIcon="user-add-fill"> </mat-icon>
            </button>
        </div>
    }
</div>